module.exports = __webpack_public_path__ + "static/media/22ESCWA23.5e7f4f28.jpg";